import React from "react";
import { Table } from "react-bootstrap";
import { AlignCenter } from "react-feather";

export default function TableSmall(props) {
  const { dataTable } = props;
  return (
    <Table bordered hover responsive>
      <tbody>
        <tr>
          <th
            rowSpan="2"
          style={{backgroundColor: "#4CAF50", color: "white", textAlign:"center", justifyContent: "center", alignItems: "center"}}
          >
            <strong>Unit</strong>
          </th>
          <th           
            style={{ backgroundColor: "#4CAF50", color: "white", textAlign:"center" }}
          >
            <strong>Antrian</strong>
          </th>
          <th         
          rowSpan="2"  
            style={{ backgroundColor: "#4CAF50", color: "white", textAlign:"center" }}
          >
            <strong>Dokter</strong>
          </th>

        </tr>
        <tr>   

                 <th           
            style={{ backgroundColor: "#4CAF50", color: "white", textAlign:"center" }}
          >
            <strong>Total</strong>
          </th>
</tr>
        {dataTable?.rows?.length > 0 ? (
          <>
            {dataTable?.rows?.map((obj, idx) => (
              <tr key={idx}>
                <td>{obj?.namaunit}</td>
                {/* {obj?.antrian == 0 ? () : ()} */}
                <td style={{ textAlign:"center" }}><b><span style={{color:"red"}}>{obj?.antrian} </span>| {obj?.total}</b></td>
                <td>{obj?.dokter}</td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan="3">Tidak ada antrian pada hari ini...</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
